import { useLocale } from '@solinkcorp/locale';
import React from 'react';
import { type LiveFeedError } from './liveFeedError';

interface LiveFeedOverlayProps {
  error: LiveFeedError;
}

/** Explains, over a dark scrim on the footage, why a live feed isn't playing. */
const LiveFeedOverlay: React.FC<LiveFeedOverlayProps> = ({ error }) => {
  const locale = useLocale();
  const { missingZoneTags, assignZoneTagsToRestoreFeed, cameraOffline, liveFeedUnavailable } =
    locale.serviceDisplayMonitor;

  const { title, subtext } =
    error === 'missingZoneTags'
      ? { title: missingZoneTags, subtext: assignZoneTagsToRestoreFeed }
      : {
          title: error === 'cameraOffline' ? cameraOffline : liveFeedUnavailable,
          subtext: locale.serviceDisplayMonitor.contactSupportIfThisContinues,
        };

  return (
    <div
      className="absolute inset-0 flex flex-col items-center justify-center gap-1 px-4 text-center bg-black/70"
      data-testid="sdm-live-feed-overlay"
      data-error={error}
    >
      <p
        className="m-0 font-semibold uppercase tracking-wider text-white"
        style={{ fontSize: 'clamp(0.75rem, 2.4vh, 1.375rem)' }}
      >
        {title}
      </p>
      {/* Opacity goes on the element: the preset maps `white` to a `var()`, which Tailwind
          can't apply an opacity modifier to — `text-white/70` compiles to nothing. */}
      <p className="m-0 text-white opacity-70" style={{ fontSize: 'clamp(0.625rem, 1.8vh, 1rem)' }}>
        {subtext}
      </p>
    </div>
  );
};

export default React.memo(LiveFeedOverlay);
